import { makeUseFilters } from '@atlassian/jira-software-burn-reports-common/src/controllers/filters-controller/index.tsx';

export const useBurnupFilters = makeUseFilters('@burnup-report/filters-controller');
